import React from 'react'
import { Button, Box, Fab, Tooltip } from '@material-ui/core'
import { HelpOutline } from '@material-ui/icons'
import { buttonStyles } from '../styles/styles'
import { browserHistory } from 'react-router'

const CreateNew = ({ add, userId }) => {
    const classes = buttonStyles();
    const handleAdd = userId => {
        add(userId)
        browserHistory.push("/settings/0")
    }
    return (
        <Box m="20px 0 0 0">
            <Button className={classes.create} onClick={() => handleAdd(userId)} >create new form</Button>
            {/* <Tooltip title="Create New Form" placement="right">
                <Fab className={classes.btnHelp} size="small">
                    <HelpOutline className={classes.iconHelp}/>
                </Fab>
            </Tooltip>             */}
        </Box>
    )
}

export default CreateNew;